import { Injectable } from '@angular/core'
import { FormBuilder, FormControl, Validators } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class FormCocinaService {
  constructor (private readonly formBuilder: FormBuilder) {}

  getDishForm () {
    return this.formBuilder.group({
      nombre: new FormControl('', { nonNullable: true }),
      categoria: new FormControl('', { nonNullable: true }),
      observaciones: new FormControl('', { nonNullable: true })
    })
  }

  getInsumoForm () {
    return this.formBuilder.group({
      id: new FormControl('', { nonNullable: true }),
      nombreInsumo: new FormControl('', { nonNullable: true }),
      cantidad: new FormControl('', [Validators.required, Validators.min(0)]),
      unidadMedida: new FormControl('', Validators.required),
      categoria: new FormControl('', { nonNullable: true }),
      peso: new FormControl('', { nonNullable: true })
    })
  }

  getSKUForm () {
    return this.formBuilder.group({
      nombreInsumo: new FormControl('', { nonNullable: true }),
      categoria: new FormControl('', { nonNullable: true }),
      peso: new FormControl('', { nonNullable: true }),
      /*       proporcion: new FormControl('', {nonNullable: true}), */
      unidadMedida: new FormControl('', { nonNullable: true }),
      estado: new FormControl('', { nonNullable: true }),
      stockTeorico: new FormControl('', { nonNullable: true }),
      stock: new FormControl('', { nonNullable: false })
    })
  }

  getMenuForm () {
    return this.formBuilder.group({
      nombre: new FormControl('', { nonNullable: true }),
      descripcion: new FormControl('', { nonNullable: true })
    })
  }

  getProveedorForm () {
    return this.formBuilder.group({
      cuentaContableDolares: new FormControl('', { nonNullable: true }),
      cuentaContableSoles: new FormControl('', { nonNullable: true }),
      direccionSocial: new FormControl('', { nonNullable: true }),
      distrito: new FormControl('', { nonNullable: true }),
      documento: new FormControl('', { nonNullable: true }),
      nombreComercial: new FormControl('', { nonNullable: true }),
      provincia: new FormControl('', { nonNullable: true }),
      razonSocial: new FormControl('', { nonNullable: true }),
      ruc: new FormControl('', { nonNullable: true }),
      telefono: new FormControl('', { nonNullable: true })
    })
  }
}
